'use client';

import { useTranslations } from 'next-intl';
import { ErrorWrapper, NotFoundPage } from '@mentimeter/error-pages';
import { useUser } from '@mentimeter/user';
import {
  usePathname,
  useRouter,
  useSearchParams,
} from '@mentimeter/next-navigation';
import { useReferral } from '@mentimeter/auth';
import { Button } from '@mentimeter/ragnar-ui/button';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Heading, P } from '@mentimeter/ragnar-ui/typography';

const NotFound = () => {
  const t = useTranslations('creation.page_errors');
  const pathName = usePathname();
  const searchParams = useSearchParams();
  const { user } = useUser();
  const referral = useReferral();
  const continueUrl = `${pathName}?${searchParams.toString()}`;
  const loginUrl = `/auth/login?continue=${encodeURIComponent(continueUrl)}&referral=${encodeURIComponent(referral)}`;
  const router = useRouter();
  return (
    <ErrorWrapper>
      {user ? ( // The user is logged in don't have access to this presentation
        <NotFoundPage />
      ) : (
        <>
          <Heading fontSize={7} textAlign="center">
            {t('login_to_continue_heading')}
          </Heading>
          <P textAlign="center">{t('login_to_access_message')}</P>
          <Box width="100%" alignItems="center">
            <Box flexDirection="row" p={3}>
              <Button
                variant="primary"
                size="large"
                onClick={() => {
                  router.push(loginUrl);
                }}
                mx="space2"
              >
                {t('login_button')}
              </Button>

              <Button
                size="large"
                variant="tertiary"
                href="mailto:hello@mentimeter.com"
                ml={3}
              >
                {t('contact_support_button')}
              </Button>
            </Box>
          </Box>
        </>
      )}
    </ErrorWrapper>
  );
};

export default NotFound;
